import { Box } from '@mui/material';

import OrganizationsListDialogs from './components/OrganizationsListDialogs';
import { OrganizationsListHeader } from './components/OrganizationsListHeader';
import { OrganizationsListTable } from './components/OrganizationsListTable';
import { OrganizationsListDialogProvider } from './context/OrganizationsListDialogContext';

const OrganizationList = () => {
  return (
    <OrganizationsListDialogProvider>
      <Box data-testid="organizations-page">
        <OrganizationsListHeader />
        <OrganizationsListTable />
        <OrganizationsListDialogs />
      </Box>
    </OrganizationsListDialogProvider>
  );
};

export default OrganizationList;
